import { render, staticRenderFns } from "./RequestMessage.vue?vue&type=template&id=a1b54f04&scoped=true&"
import script from "./RequestMessage.vue?vue&type=script&lang=js&"
export * from "./RequestMessage.vue?vue&type=script&lang=js&"
import style0 from "./RequestMessage.vue?vue&type=style&index=0&id=a1b54f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b54f04",
  null
  
)

export default component.exports